import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import Y from '../../y18n'
import api from '../api'

const GET_USERS = createAction('users/GET_USERS')
const GET_USERS_SUCCESS = createAction('users/GET_USERS_SUCCESS')

const CLEAR_USERS = createAction('users/CLEAR_USERS')

const CREATE_USER = createAction('users/CREATE_USER')
const CREATE_USER_SUCCESS = createAction('users/CREATE_USER_SUCCESS')

const EDIT_USER = createAction('users/EDIT_USER')
const EDIT_USER_SUCCESS = createAction('users/EDIT_USER_SUCCESS')

const DELETE_USERS = createAction('users/DELETE_USERS')
const DELETE_USERS_SUCCESS = createAction('users/DELETE_USERS_SUCCESS')

const VERIFY_EMAIL = createAction('users/VERIFY_EMAIL')
const VERIFY_EMAIL_SUCCESS = createAction('users/VERIFY_EMAIL_SUCCESS')

const SET_ERROR = createAction('users/SET_ERROR')

const SELECT_ITEM = createAction('users/SELECT_ITEM')
const UNSELECT_ITEM = createAction('users/UNSELECT_ITEM')
const UNSELECT_ALL = createAction('users/UNSELECT_ALL')
const TOGGLE_ALL = createAction('users/TOGGLE_ALL')

const SET_ACTIVE = createAction('users/SET_ACTIVE')
const RESET_ACTIVE = createAction('users/RESET_ACTIVE')
const UPDATE_ACTIVE = createAction('users/UPDATE_ACTIVE')

const SET_TEMP_PASSWORD = createAction('users/SET_TEMP_PASSWORD')
const RESET_TEMP_PASSWORD = createAction('users/RESET_TEMP_PASSWORD')

const SET_NEW = createAction('users/SET_NEW')
const RESET_NEW = createAction('users/RESET_NEW')

const VIEW_HISTORY = createAction('users/VIEW_HISTORY')
const VIEW_HISTORY_SUCCESS = createAction('users/VIEW_HISTORY_SUCCESS')
const HIDE_HISTORY = createAction('users/HIDE_HISTORY')

const SET_PAGE = createAction('users/SET_PAGE')
const SET_ROWS_PER_PAGE = createAction('users/SET_ROWS_PER_PAGE')

const SET_SORT = createAction('users/SET_SORT')
const SET_FILTER = createAction('users/SET_FILTER')

const UNBLOCK_USER = createAction('users/UNBLOCK_USER')
const UNBLOCK_USER_SUCCESS = createAction('users/UNBLOCK_USER_SUCCESS')

const initialState = {
  items: [],
  selectedItems: [],
  itemCount: 0,
  allSelected: false,
  active: null,
  new: false,
  loading: false,
  history: false,
  historyLoading: false,
  tempPassword: { status: false, id: null },
  sort: { orderBy: 'email', direction: 'asc' },
  filter: { country: '', role: '' },
  rowsPerPage: 25,
  page: 0
}

export default handleActions(
  {
    [GET_USERS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_USERS_SUCCESS]: (state, action) => {
      action.payload.users.forEach(function (e) {
        e.checked = false
      })
      var items = !state.items.length || action.payload.search
        ? action.payload.users
        : state.items.concat(action.payload.users)
      var page = action.payload.search ? 0 : state.page
      return {
        ...state,
        loading: false,
        items: items,
        itemCount: action.payload.totalCount,
        page: page
      }
    },
    [CLEAR_USERS]: (state, action) => ({
      ...state,
      items: []
    }),
    [CREATE_USER]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CREATE_USER_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [EDIT_USER]: (state, action) => ({
      ...state,
      loading: true
    }),
    [EDIT_USER_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_USERS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_USERS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [VERIFY_EMAIL]: (state, action) => ({
      ...state,
      loading: false
    }),
    [VERIFY_EMAIL_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = true
      state.selectedItems.push({ ...selectedItem })
      var all = state.items && state.selectedItems ? state.items.length === state.selectedItems.length : false

      return {
        ...state,
        items: state.items,
        selectedItems: state.selectedItems,
        allSelected: all
      }
    },
    [UNSELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = false
      var selectedItems = state.selectedItems.filter(function (element) {
        return element.id !== selectedItem.id
      })
      return {
        ...state,
        items: state.items,
        selectedItems: selectedItems,
        allSelected: false
      }
    },
    [UNSELECT_ALL]: (state, action) => ({
      ...state,
      selectedItems: [],
      allSelected: false
    }),
    [TOGGLE_ALL]: (state, action) => {
      var checked = !action.payload
      state.items.forEach(function (item) {
        item.checked = checked
      })
      return {
        ...state,
        items: state.items,
        selectedItems: checked ? [...state.items] : [],
        allSelected: checked
      }
    },
    [SET_ACTIVE]: (state, action) => ({
      ...state,
      active: { ...action.payload }
    }),
    [RESET_ACTIVE]: (state, action) => ({
      ...state,
      active: null
    }),
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    },
    [SET_TEMP_PASSWORD]: (state, action) => ({
      ...state,
      tempPassword: { status: action.payload.status, id: action.payload.id }
    }),
    [RESET_TEMP_PASSWORD]: (state, action) => ({
      ...state,
      tempPassword: { status: false, id: null }
    }),
    [SET_NEW]: (state, action) => ({
      ...state,
      active: action.payload,
      new: true
    }),
    [RESET_NEW]: (state, action) => ({
      ...state,
      active: null,
      new: false
    }),
    [VIEW_HISTORY]: (state, action) => ({
      ...state,
      historyLoading: true,
      history: true
    }),
    [VIEW_HISTORY_SUCCESS]: (state, action) => ({
      ...state,
      active: action.payload,
      historyLoading: false
    }),
    [HIDE_HISTORY]: (state, action) => ({
      ...state,
      active: null,
      history: false
    }),
    [SET_PAGE]: (state, action) => ({
      ...state,
      page: action.payload
    }),
    [SET_ROWS_PER_PAGE]: (state, action) => ({
      ...state,
      rowsPerPage: action.payload
    }),
    [SET_SORT]: (state, action) => ({
      ...state,
      sort: {
        orderBy: action.payload,
        direction: state.sort.direction === 'asc' ? 'desc' : 'asc'
      }
    }),
    [SET_FILTER]: (state, action) => {
      let filter = state.filter
      filter[action.payload.name] = action.payload.value
      return { ...state, filter: filter }
    },
    [UNBLOCK_USER]: (state, action) => ({
      ...state,
      loading: true
    }),
    [UNBLOCK_USER_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    })
  },
  initialState
)

export const getUsers = (searchText = null) => {
  return (dispatch, getState) => {
    const page = getState().users.page
    const rowsPerPage = getState().users.rowsPerPage
    const items = getState().users.items
    if (searchText === null && items.length !== 0 && page * rowsPerPage < items.length) return null
    if (searchText !== null) {
      dispatch(CLEAR_USERS())
    }
    dispatch(GET_USERS())
    return api
      .get('users/getUsers', '', `page=${page}&count=${rowsPerPage}&searchText=${searchText || ''}`)
      .then(result => {
        dispatch(GET_USERS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const searchUsers = email => {
  return dispatch => {
    dispatch(GET_USERS())
    return api
      .get('users/searchUsers', '', `email=${email}`)
      .then(result => {
        dispatch(GET_USERS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const search = searchText => {
  return dispatch => {
    dispatch(getUsers(searchText))
  }
}

export const setTempPassword = (status, id = null) => {
  return dispatch => {
    dispatch(SET_TEMP_PASSWORD({ status, id }))
  }
}

export const resetTempPassword = () => {
  return dispatch => {
    dispatch(RESET_TEMP_PASSWORD())
  }
}

export const submitTempPassword = (id, password) => {
  return dispatch => {
    return api
      .post('users/setTemporaryPassword', id, { password: password })
      .then(result => {
        dispatch(RESET_TEMP_PASSWORD())
        dispatch(globalMessageActions.setGlobalSuccess(Y`Temporary password for user set successfully`))
      })
      .catch(error => {
        dispatch(RESET_TEMP_PASSWORD())
        dispatch(globalMessageActions.setGlobalError(Y`${error}`))
      })
  }
}

export const clearUsers = () => {
  return dispatch => {
    dispatch(CLEAR_USERS())
  }
}

export const createUser = user => {
  return dispatch => {
    dispatch(CREATE_USER())
    return api
      .post('users/createUser', '', user)
      .then(result => {
        dispatch(CREATE_USER_SUCCESS(result))
        dispatch(getUsers())
        dispatch(resetNew())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const editUser = user => {
  return dispatch => {
    dispatch(EDIT_USER())
    return api
      .post('users/updateUser', user.id, user)
      .then(result => {
        dispatch(EDIT_USER_SUCCESS(result))
        dispatch(clearUsers())
        dispatch(getUsers())
        dispatch(resetActive())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const deleteItems = users => {
  return (dispatch, getState) => {
    const userIds = getState().users.selectedItems.map(u => u.id)
    dispatch(DELETE_USERS())
    return api
      .post('users/deleteUsers', null, { userIds: userIds })
      .then(result => {
        dispatch(DELETE_USERS_SUCCESS(result))
        dispatch(getUsers())
        dispatch(unselectAll())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const unblockUser = id => {
  return dispatch => {
    dispatch(UNBLOCK_USER())
    return api
      .post('users/unblockUser', id, '')
      .then(result => {
        dispatch(UNBLOCK_USER_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR(error))
      })
  }
}

export const viewHistory = user => {
  return dispatch => {
    dispatch(VIEW_HISTORY())
    return api
      .get('users/getUser', user.id, '')
      .then(result => {
        dispatch(VIEW_HISTORY_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR(error))
      })
  }
}

export const setActive = user => {
  return dispatch => {
    dispatch(SET_ACTIVE(user))
  }
}

export const resetActive = () => {
  return dispatch => {
    dispatch(RESET_ACTIVE())
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}

export const selectItem = item => {
  return dispatch => {
    dispatch(SELECT_ITEM(item))
  }
}

export const unselectItem = item => {
  return dispatch => {
    dispatch(UNSELECT_ITEM(item))
  }
}

export const unselectAll = () => {
  return dispatch => {
    dispatch(UNSELECT_ALL())
  }
}

export const toggleAll = checked => {
  return dispatch => {
    dispatch(TOGGLE_ALL(checked))
  }
}

export const setNew = () => {
  return dispatch => {
    // init a new user
    const user = {
      firstName: '',
      lastName: '',
      email: '',
      address: '',
      zipCode: '',
      city: '',
      country: '',
      role: ''
    }
    dispatch(SET_NEW(user))
  }
}

export const resetNew = () => {
  return dispatch => {
    dispatch(RESET_NEW())
  }
}

export const hideHistory = () => {
  return dispatch => {
    dispatch(HIDE_HISTORY())
  }
}

export const setSort = value => {
  return dispatch => {
    dispatch(SET_SORT(value))
  }
}

export const setFilter = (name, value) => {
  return dispatch => {
    dispatch(SET_FILTER({ name, value }))
  }
}

export const setPage = value => {
  return dispatch => {
    dispatch(SET_PAGE(value))
  }
}

export const setRowsPerPage = value => {
  return dispatch => {
    dispatch(SET_ROWS_PER_PAGE(value))
  }
}



// WEBPACK FOOTER //
// ./src/store/users/index.js